interface Props {
  image: HeroImage
}

const heroImage = {
  Home: `bg-[url('assets/home-hero.jpg')]` as const,
  About: `bg-[url('assets/about.jpg')]` as const,
  Gospel: `bg-[url('assets/gospel.jpg')]` as const,
  Contact: `bg-[url('assets/contact-us.jpg')]` as const,
}

export type HeroImage = keyof typeof heroImage

export default function HeroShade({ image }: Props) {
  return (
    <>
      <div
        className={`absolute left-0 top-0 right-0 bottom-0 bg-cover bg-center justify-center ${heroImage[image]}`}
      />
      <div
        className={
          'absolute top-0 right-0 bottom-0 left-0 bg-[linear-gradient(0deg,_#ffffffed_0%,_#ffffffff_45%,_#ffffff00)] md:bg-[linear-gradient(35deg,_#fffffffc_0%,_#ffffffef_45%,_#ffffff00)] lg:bg-[linear-gradient(135deg,_#ffffff_0%,_#ffffff_35%,_#ffffff00)] transition-all'
        }
      />
    </>
  )
}
